// Module
var code = "<span class=\"tweet-btn\">\n  <btn\n    :size=\"size\"\n    icon-name=\"ion-social-twitter\"\n    @click=\"share()\">\n    Tweet\n  </btn>\n</span>\n";
// Exports
export default code;